export const TIME_ZONE_FORMAT = 'HH:mm:ss O';
export const DATE_TIME_ZONE_FORMAT = `yyyy-MM-dd, ${TIME_ZONE_FORMAT}`;
export const DATE_TIME_FORMAT = 'd MMM y, HH:mm';
export const SCORESHEET_DATE_TIME_FORMAT = 'EEEE, MMM d, y, HH:mm z';
